const NAMESPACE = "pcMap";

const KEYS = {
    retryButtonLabel: "retryButtonLabel",
    serviceUnavailableMessage: "serviceUnavailableMessage"
};

const MESSAGES = {
    [KEYS.retryButtonLabel]: {
        value: "Retry",
        comment:
            "Label for button that allows user to retry the connection to the map service if the initial connection failed."
    },
    [KEYS.serviceUnavailableMessage]: {
        value: "Map service unavailable",
        comment:
            "Message that appears instead of the map component if the service that provides the map is unavailable."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
